import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const IncompleteProfileModal = ({
  isModalOpen,
  setIsModalOpen,
  setIsEditModalOpen,
  incompleteProfileNotifier,
  Error,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={isModalOpen}
      onHide={() => setIsModalOpen(false)}
      centered
      aria-labelledby="incompleteProfileModalLabel"
    >
      <Modal.Header>
        <Modal.Title id="incompleteProfileModalLabel" className="w-100">
          {t("IncompleteProfileModal.Incomplete Profile")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="mb-3">
          <img src={Error} alt="Error icon" width="20%" className="img-fluid" />
        </div>
        <p>
          {t("IncompleteProfileModal.Please Provide The Missing")} -
          <span className="ms-1 fw-bold text-warning">
            {incompleteProfileNotifier}
          </span>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            setIsModalOpen(false);
            setIsEditModalOpen(true);
          }}
        >
          {t("IncompleteProfileModal.Complete Profile")}
        </Button>
        <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
          {t("Cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IncompleteProfileModal;
